'use strict';

/**
 * @ngdoc function
 * @name 360StoreAngularApp.controller:VerifyLoginCtrl
 * @description
 * # VerifyLoginCtrl
 * Controller of the 360StoreAngularApp
 */
angular.module('360StoreAngularApp')
	.controller('VerifyLoginCtrl', function ($scope, $location, $timeout, api, session) {

		$scope.verificationStatus = 'verifying';
		$scope.errorMessage = 'An unknown error occurred.';

		function verifyToken(token) {
			api.verifyLoginLink(token)
				.then(function (account) {
					session.account = account; // Manually set the session
					$scope.verificationStatus = 'success';
					toastr.success('You are now logged in.', 'Login Successful');
					$timeout(function () {
						$location.path('/my-licenses').search({}); // Clear URL params
					}, 2000);
				})
				.catch(function (error) {
					$scope.verificationStatus = 'error';
					$scope.errorMessage = error.data.error || 'This login link is invalid or has expired.';
					toastr.error($scope.errorMessage, 'Login Failed');
				});
		}

		const tokenFromUrl = $location.search().token;

		if (tokenFromUrl) {
			verifyToken(tokenFromUrl);
		} else {
			$scope.verificationStatus = 'error';
			$scope.errorMessage = 'No login token found in the URL.';
		}
	});
